<template>
  <ContentTemplate title="General" :container-size-small="true">
    <form>
      <FormGroupSection
          :form-element="languageInput"
          v-model:input-value="form[languageInput.input.name]"
      />

      <hr/>

      <div class="form-group">
        <div class="row">
          <div class="col-4">
            <FormGroupLabelSection
                label="Workspaces"
                icon="User"
                icon-type="fal"
            />
          </div>
          <div class="col-8">
            <WorkspaceAccessSection v-for="(item, index) in workspaceList"
                                    :key="index"
                                    :workspace="item"
                                    :with-button="true" :is-disable="false"
                                    @deleteWorkspace="onDeleteWorkspace"
                                    @leftWorkspace="onLeftWorkspace"
            />
          </div>
        </div>
      </div>

      <hr/>

      <div class="form-group">
        <div class="row">
          <div class="col-4">
            <FormGroupLabelSection
                label="Login Activity"
                icon="MonitorSmartphone"
                icon-type="fal"
            />
          </div>
          <div class="col-8">
            <ButtonElement class="btn--ms btn--neutral btn--regular"
                           @clickOnButton="goToLoginActivity()">
              Open Login Activity
            </ButtonElement>
          </div>
        </div>
      </div>

      <hr/>

      <div class="form-group">
        <div class="row">
          <div class="col-4">
            <FormGroupLabelSection
                label="Delete Account"
                icon="Ban"
                icon-type="fal"
            />
          </div>
          <div class="col-8">
            <ButtonElement class="btn--ms btn--danger btn--regular"
                           @clickOnButton="goToDangerZone()">
              Open Danger Zone
            </ButtonElement>
          </div>
        </div>
        <FormGroupDescriptionSection
            description="Not using metastory AI anymore? Enter the password to close the account and workspace."></FormGroupDescriptionSection>
      </div>

    </form>
  </ContentTemplate>

</template>
<script lang="ts">
import {defineComponent} from 'vue';
import {AccountNs, CommonNs, WorkspaceNs,} from '@shared/types';
import FormGroupDescriptionSection from '@shared/components/sections/form-group-description.section.vue';
import {
  ButtonElement,
  ContentTemplate,
  FormGroupLabelSection,
  FormGroupSection,
  WorkspaceAccessSection
} from "@shared/components";
import {LanguageOptions} from "@shared/constants";
import {mapStores} from "pinia";
import {useAccountStore} from "@domains/account/stores/account.store";
import {useGeneralStore} from "@shared/stores/general.store";
import {toast} from '@shared/ms-components'

export default defineComponent({
  name: 'GeneralView',
  components: {
    FormGroupDescriptionSection,
    ContentTemplate,
    FormGroupSection,
    WorkspaceAccessSection,
    FormGroupLabelSection,
    ButtonElement,
  },
  computed: {
    ...mapStores(useAccountStore, useGeneralStore),
    workspaceList(): WorkspaceNs.Workspace[] {
      return this.accountStore.getGeneralInfo.workspaces;
    },
  },
  data() {
    return {
      form: {} as { [key: string]: any },

      languageInput: {} as CommonNs.InputFormGroup,
      newsletterInput: {} as CommonNs.InputFormGroup,

      loginActivityForm: {} as CommonNs.InputFormGroup,
      deleteAccountForm: {} as CommonNs.InputFormGroup,
    };
  },

  beforeMount() {
    this.buildForm();
    this.initFormData();
  },
  methods: {
    buildForm(): void {
      this.languageInput = {
        label: 'Language',
        iconType: 'fal',
        icon: 'Globe',
        input: {
          name: 'language',
          type: 'select',
          placeholder: 'Select',
          selectOptions: LanguageOptions,
          isDisable: true,
        },
      } as CommonNs.InputFormGroup;

      this.newsletterInput = {
        label: 'Newsletter',
        iconType: 'fal',
        icon: 'MailOpen',
        description: 'Send me news and offers from metastory about products, events and more.',
        input: {
          name: 'newsletter',
          type: 'switch',
        },
      } as CommonNs.InputFormGroup;

      this.loginActivityForm = {
        label: 'Login Activity',
        iconType: 'fal',
        icon: 'MonitorSmartphone',
        input: {
          name: 'Open Login Activity',
          type: 'button',
        },
      } as CommonNs.InputFormGroup;

      this.deleteAccountForm = {
        label: 'Delete Account',
        iconType: 'fal',
        icon: 'Ban',
        description: 'Don\'t feel like using metastory anymore? Just type your password and we\'ll help you close down your account and workspace.',
        input: {
          name: 'Open Danger Zone',
          type: 'button',
        },
      } as CommonNs.InputFormGroup;
    },

    initFormData() {
      const generalInfo = this.accountStore.getGeneralInfo;

      this.form = {
        language: generalInfo.language ?? 'English',
        newsletter: generalInfo.newsletter ?? false,
      };
    },

    saveForm() {
      const payload = {
        language: this.form.language,
        newsletter: this.form.newsletter,
      } as AccountNs.UpdateGeneralInfoRequest;

      this.accountStore.updateGeneralInfo(payload).then(() => {
        toast.success('Changes saved');
      })
    },

    onDeleteWorkspace(workspaceId: string) {
      const data = {
        workspaceId,
      };

      this.$router.push({
        name: AccountNs.AccountRouteEnums.DELETE_WORKSPACE,
        params: data,
      });
    },

    onLeftWorkspace(workspaceId: number) {
      const data = {
        workspaceId,
      };

      this.$router.push({
        name: AccountNs.AccountRouteEnums.LEAVE_WORKSPACE,
        params: data,
      });
    },

    goToLoginActivity() {
      this.$router.push({name: AccountNs.AccountRouteEnums.LOGINACTIVITY});
    },

    goToDangerZone() {
      this.$router.push({name: AccountNs.AccountRouteEnums.DANGERZONE});
    },

  },
});
</script>

<style lang="scss" scoped>

hr {
  margin: 30px 0;
}

.fp-form-group {
  & .description {
    p {
      font-size: var(--fs-12);
      font-weight: 400;
      color: var(--text-neutral);
      margin: var(--space-0);
    }
  }
}


</style>
